import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { WMSSelect } from "../../../widgets/selectbox";
import { WMSInput } from "../../../widgets/input";
import { TableLineLoader } from "../../../widgets/tableloader";
// import { taskColumn } from "../../widgets/tableColumn";
import "./index.scss";
import { toastError, toastSuccess, toastWarning } from "../../../widgets/toaster";
import { apiUrl } from "../../../base/utils";
import WHSLoader from "../../../widgets/loader";
import { invokeGetService, invokePostService } from "../../../service";
import { dispatchStepAction, dispatchFileUpload } from "../../../redux/action";
import CustomTable from "../../table/customTable";
import { createColumnHelper } from "@tanstack/table-core";
import HOCAutoLogout from "../../autologout";
import moment from "moment";

const columnHelper = createColumnHelper();
interface Row {
    getValue: () => any;
    row: any;
}

interface DownloadProgress {
    [articleId: string]: boolean;
}

function ReviewerManuscript(props: any) {
    const [isTableLoader] = useState(false);
    // const [columns, setColumns] = useState(taskColumn);
    const [tableData, setTableData] = useState([]);
    const [initialData, setInitialData] = useState([]);
    const [selectfileterData, setselectfileterData] = useState([]);
    // const [pagination, setPagination] = useState({ startIndex: 0, endIndex: 5 });
    const [message, setMessageContent] = useState("");
    const [suggestion, setsuggestion] = useState("");
    const [messageuggestion, setMessageuggestionContent] = useState("");

    const [constentId, setContentId] = useState(0);
    const [stageDropdown, setStageDropdown] = useState([]);
    const [currentlyDropdown, setCurrentlyDropdown] = useState([]);
    const [showAcceptReject, setShowAcceptReject] = useState<{ [key: string]: boolean }>({});
    const [isModalshow, setisModalshow] = useState(false);
    const [isAcceptModalshow, setisAcceptModalshow] = useState(false);
    const [isDeclineModalshow, setisDeclineModalshow] = useState(false);
    const [confirmationStatus, setConfirmationStatus] = useState('');
    const [declineconfirmationStatus, setdeclineconfirmationStatus] = useState('');
    const [pdfDownloadInProgress, setPdfDownloadInProgress] = useState<DownloadProgress>({});

    const [stageValue, setStageValue] = useState({
        label: "All Status",
        value: "All Status",
    });
    // const [statusValue, setStatusValue] = useState('All Status');
    const [currentlywithValue, setCurrentlyValue] = useState({
        label: "All Users",
        value: "Currently with All",
    });

    const [render, setRender] = useState(false);
    const [searchData, setSearchData] = useState("");
    const [isMsgModal, setMsgModal] = useState(false);
    // const [recordpage, setRecordPage] = useState(5);
    const [isLoader, setLoader] = useState(false);

    const navigate = useNavigate();

    const WS_URL: string = process.env.REACT_APP_WS_URL || "";

//   useEffect(() => {
//     const ws = new WebSocket(WS_URL);
  
//     ws.onmessage = (event) => {
//       const data = JSON.parse(event.data);
  
//       if (data.type === 'REVIEWER_STAGE_UPDATED') {
//         console.log('event.data', event.data)
//         getJournalTitelList("table_list");
//       }
//     };
  
//     return () => ws.close();
//   }, []);

useEffect(() => {
    const ws = new WebSocket(WS_URL);
  
    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
  
      if (data.type === 'REVIEWER_STAGE_UPDATED') {
        console.log('event.data', event.data);
        
        // Set 10-second timer before calling getJournalTitelList
        setTimeout(() => {
          getJournalTitelList("table_list");
        }, 10000); // 10 seconds delay
      }
    };
  
    return () => ws.close();
  }, []);

    function truncateText(text: string, numWords: any) {
        const words = text.split(" ");
        const truncated = words.slice(0, numWords).join(" ");
        if (words.length > numWords) {
            return truncated.replace(/<[^>]*>/g, "");
        }
        return truncated.replace(/<[^>]*>/g, "");
    }

    // const isAcceptModalshowfun = ()=>{
    //     setisAcceptModalshow(true)
    // }
    const handleUpdateReviewerInviteStatus = async (statusCode: string) => {
        const url = apiUrl.nodeApi.updateReviewerInviteStatusFromLink;
        setLoader(true);
        const startTime = Date.now();
      
        try {
          const payload = { status_code: statusCode };
          const response: any = await invokePostService(url, payload, props.isToken);
      
          if (!response.data.data.isSuccess) {
            throw new Error(response.data.data.Error);
          }
          
          toastSuccess("Reviewer Invite Status Updated Successfully");
          setConfirmationStatus('');
          setdeclineconfirmationStatus('');
          
          await Promise.all([
            getJournalTitelList("data"),
            refreshTable()
          ]);
          
          const elapsedTime = Date.now() - startTime;
          const remainingTime = Math.max(5000 - elapsedTime, 0);
          
          setTimeout(() => {
            setLoader(false);
          }, remainingTime);
          
        } catch (error) {
          const elapsedTime = Date.now() - startTime;
          const remainingTime = Math.max(5000 - elapsedTime, 0);
          toastError(`Failed to update Reviewer Invite Status: ${error}`);
          setTimeout(() => {
            setLoader(false);
          }, remainingTime);
        }
    };
    const formatedDate = (dateString: string, journal: string) => {
        const date = new Date(dateString);
        return moment(date).format('DD-MM-YYYY');
    };
    const getGrayOutStyle = (row: Row) =>
        row?.row?.original?.last_invited === true
            ? { color: "#999", opacity: 0.7 }
            : {};
    const taskColumns = [
        columnHelper.accessor("serial", {
            header: "S.No",
            cell: (row: Row) => (
                <span style={getGrayOutStyle(row)}>{row.getValue()}</span>
            ),
        }),
        columnHelper.accessor("articlename", {
            header: "Article Id",
            cell: (row: Row) => (
                <span style={getGrayOutStyle(row)}>{row.getValue()}</span>
            ),
        }),
        columnHelper.accessor("articletitle", {
            header: "Article Title",
            cell: (row: Row) => {
                const item = row?.getValue() || "";
                const cleanedItem = item.replace(/<[^>]*>/g, "");
                const truncatedItem = truncateText(cleanedItem, 2);
                const displayItem =
                    cleanedItem.length > truncatedItem.length
                        ? truncatedItem + "..."
                        : truncatedItem;
                return (
                    <span className="visible" style={getGrayOutStyle(row)} title={cleanedItem}>
                        {displayItem}
                    </span>
                );
            },
        }),

        columnHelper.accessor("journal", {
            header: "Journal",
            cell: (row: Row) => {
                const item = row?.getValue() || "";
                const hoverText = row?.row?.original?.journalname;
                return (
                    <span className="visible" style={getGrayOutStyle(row)} title={hoverText}>
                        {item}
                    </span>
                );
            },
        }),
        columnHelper.accessor("created_date", {
            header: "Due Date",
            cell: (row: Row) => {
                const journalType = row?.row?.original.journal;
                // Return dash for CMLR and TAXI journals
                if (journalType === 'CMLR' || journalType === 'TAXI') {
                    return (
                        <span className="visible">-</span>
                    );
                }

                const createdDate = row?.row?.original?.created_date;
                const articleDurations: any = {
                    AIAJ: 3, // weeks
                    EFAR: 3, // weeks
                    IJCL: 1, // month
                };
                const duration = articleDurations[journalType] || 0;
                let dueDate;

                if (duration > 0) {
                    if (journalType === 'IJCL') {
                        dueDate = createdDate ? moment(createdDate).add(duration, 'months') : moment().add(duration, 'months');
                    } else {
                        dueDate = createdDate ? moment(createdDate).add(duration, 'weeks') : moment().add(duration, 'weeks');
                    }
                } else {
                    dueDate = createdDate ? moment(createdDate).add(20, 'days') : moment().add(20, 'days');
                }

                return (
                    <span className="visible" style={getGrayOutStyle(row)}>
                        {dueDate ? dueDate.format('DD-MM-YYYY') : 'N/A'}
                    </span>
                );
            },
        }),
        columnHelper.accessor("submitted_date", {
            header: "Submission Date",
            cell: (props: any) => formatedDate(props.getValue(), props.row.original.journal)
        }),
        columnHelper.accessor("stage", {
            header: "Status",
            cell: (row: Row) => {
                const value = row.getValue();
                let className = "cellStyle";
                let displayValue = value;

                // Setting className and displayValue based on the value
                switch (value) {
                    case "review completed":
                        className += " greenbadge";
                        break;
                    case "awaiting response from reviewer":
                        className += " yellowBadge";
                        displayValue = "awaiting response";
                        break;
                    case "invitation declined":
                        className += " failed";
                        displayValue = "invitation declined";
                        break;
                    case "reviewing manuscript":
                        className += " reviewingManuscript";
                        break;
                    case "revoked access":
                        className += " failed";
                        break;
                    default:
                }

                return <span style={getGrayOutStyle(row)} className={className}>{displayValue}</span>;
            },
        }),
        columnHelper.accessor("revisioncount", {
            header: "Stage",
            cell: (row: Row) => {
                const revisioncount = row?.row?.original?.revisioncount;

                let revision;
                if (revisioncount === 0) {
                    revision = 'First Review';
                } else {
                    revision = `Revision ${revisioncount}`;
                }

                return (
                    <span className="visible" style={getGrayOutStyle(row)} title={revisioncount}>
                        {revision}
                    </span>
                );
            },
        }),
        columnHelper.accessor("action", {
            header: "Action",
            cell: (row: any) => {
                const rowData = row?.row?.original;
                const isPlay = rowData?.isplay === 1;
                const isAuthorEnabled = rowData?.iauthorenable === 0;
                const isDisabled = rowData?.stage === "revoked access" || rowData?.stage === "invitation declined"; // Disable on both stages
            
                const handlesuggestion = (suggestion_name: any, suggestion_msg: any) => {
                    setisModalshow(true);
                    setsuggestion(suggestion_name);
                    setMessageuggestionContent(suggestion_msg);
                };
            
                return (
                    <div style={{ textAlign: "center" }}>
                        {isAuthorEnabled && !isDisabled ? (
                            <>
                                <button
                                    className="iconBtn"
                                    onClick={() => handleModalOpen(rowData?.status_codes[1].status_code)}
                                    style={{ border: "none", background: "none",
                                        ...getGrayOutStyle(rowData) }}
                                    title="Accept"
                                    disabled={isDisabled || rowData?.last_invited} // Disable when access is revoked or invitation declined
                                >
                                    <span
                                        className="material-symbols-outlined"
                                        style={{ color: isDisabled ? "#ccc" : "#09ae2d",
                                            ...getGrayOutStyle(rowData) }}
                                        
                                    >
                                        check_circle
                                    </span>
                                </button>
            
                                <button
                                    className="iconBtn"
                                    onClick={() => handleDeclineModalOpen(rowData?.status_codes[0].status_code)}
                                    style={{ border: "none", background: "none",
                                        ...getGrayOutStyle(rowData) }}
                                    title="Reject"
                                    disabled={isDisabled || rowData?.last_invited} // Disable when access is revoked or invitation declined
                                >
                                    <span
                                        className="material-icons f-20"
                                        style={{ color: isDisabled ? "#ccc" : "#C62026",
                                            ...getGrayOutStyle(rowData) }}
                                    >
                                        cancel
                                    </span>
                                </button>
                            </>
                        ) : (
                            <>
                                <button
                                    className="iconBtn"
                                    onClick={() => iAuthorDetails(rowData)}
                                    disabled={isDisabled || rowData?.iauthorenable === 0 || rowData?.articleguid == null ||rowData?.last_invited}
                                    style={{ border: "none", background: "none" ,
                                        ...getGrayOutStyle(rowData)}}
                                    title="iAuthor"
                                >
                                    <span className="ia-btn f-20" style={getGrayOutStyle(row)} title="iAuthor">
                                        iA
                                    </span>
                                </button>
            
                                <button
                                    className="iconBtn"
                                    onClick={() => handlepdf(rowData)}
                                    id="info_btn"
                                    disabled={isDisabled || pdfDownloadInProgress[rowData.reviewerarticleguid]} 
                                    style={{ border: 'none', background: 'none',
                                        ...getGrayOutStyle(rowData) }}
                                    title={
                                        isDisabled 
                                            ? "Access Revoked / Invitation Declined" 
                                            : pdfDownloadInProgress[rowData.reviewerarticleguid] 
                                            ? "Download in progress" 
                                            : "Manuscript PDF"
                                    }
                                >
                                    {pdfDownloadInProgress[rowData.reviewerarticleguid] ? (
                                        <div className="loader"></div>
                                    ) : (
                                        <span className="material-icons f-20" style={getGrayOutStyle(row)}>picture_as_pdf</span>
                                    )}
                                </button>
            
                                {isPlay && isAuthorEnabled && (
                                    <button
                                        className="iconBtn"
                                        onClick={() => subMissionDetails(rowData)}
                                        title="Resume Manuscript Summary"
                                        style={getGrayOutStyle(row)}
                                        disabled={isDisabled} // Disable when access is revoked or invitation declined
                                    >
                                        <i className="bi bi-play" style={getGrayOutStyle(row)}></i>
                                    </button>
                                )}
            
                                <button
                                    className="iconBtn"
                                    onClick={() => handlesuggestion(rowData?.suggestion_name, rowData?.suggestion_msg)}
                                    disabled={isDisabled || !rowData?.suggestion_name}
                                    
                                    style={{ paddingTop: '3px', border: "none", background: "none",
                                        ...getGrayOutStyle(rowData) }}
                                    title="Suggestions"
                                >
                                    <span
                                        className="material-icons f-20"
                                        title="Suggestions"
                                        style={getGrayOutStyle(row)}
                                    >
                                        forum
                                    </span>
                                </button>
                            </>
                        )}
                    </div>
                );
            },
            

        })

    ];

    const handlepdf = async (item: any) => {
        const rowId = item.reviewerarticleguid; // Use a unique identifier like `articleid`
        try {
            const reqPayload = {
                activityid: item.lastactivityid,
                article_guid: item.reviewerarticleguid,
            };
            setPdfDownloadInProgress((prevState: DownloadProgress) => ({
                ...prevState,
                [rowId]: true,
            }));

            setLoader(true);

            const timer = setTimeout(() => {
                setLoader(false);
                toastWarning("Download in progress, Please wait for few Minutes.");
            }, 2000);

            const url = apiUrl.nodeApi.getPdfLinkByActivity;
            const response: any = await invokePostService(url, reqPayload, props.isToken);

            if (response.data.isSuccess) {
                const newWindow = window.open(response.data.result.downloadUrl, '_blank');
                if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
                    toastWarning("Browser blocked pop-ups. Click the pop-up blocker icon in the address bar and choose 'Allow pop-ups for this site'.");
                }
            }

            setLoader(false);

            setPdfDownloadInProgress((prevState: DownloadProgress) => ({
                ...prevState,
                [rowId]: false,
            }));

            clearTimeout(timer);

            if (!response.data.isSuccess) {
                throw new Error(response.data.Error);
            }
        } catch (error) {
            setLoader(false);
            setPdfDownloadInProgress((prevState: DownloadProgress) => ({
                ...prevState,
                [rowId]: false,
            }));
            toastWarning("The requested PDF is not available yet. Please try again after a few minutes.");
        }
    };

    const getSuggestionTitleColor = (title: string) => {
        switch (title) {
            case "Accept":
                return "green";
            case "Reject":
                return "red";
            // case "Revise with minor change":
            //   return "darkblue";
            default:
                return "darkblue";
        }
    };
    const filterTableData = (journalOption: any, authorOption: any) => {
        const journalValue = journalOption.value
            ? journalOption.value.toLowerCase()
            : "";
        const authorValue = authorOption.value
            ? authorOption.value.toLowerCase()
            : "";
        let filteredData: any;

        if (journalValue !== "all status" && authorValue !== "currently with all") {
            filteredData = initialData.filter(
                (list: any) =>
                    list.stage.toLowerCase() === journalValue &&
                    list.currentlywith.toLowerCase() === authorValue
            );

        } else if (journalValue !== "all status") {
            filteredData = initialData.filter(
                (list: any) => list.stage.toLowerCase() === journalValue
            );
        } else if (authorValue !== "currently with all") {
            filteredData = initialData.filter(
                (list: any) => list.currentlywith.toLowerCase() === authorValue
            );
        } else {
            filteredData = initialData;
        }

        if (filteredData) {
            const updatedData = filteredData.map((list: any, i: any) => {
                return { ...list, serial: i + 1 };
            });
            setselectfileterData(updatedData);
            setTableData(updatedData);
        }
    };

    useEffect(() => {
        getJournalTitelList("table_list");
        getStagesList("stages");
        getUserRole("roles");
    }, []);

    const getJournalTitelList = async (type: any) => {
        try {
            setLoader(true);
            let url = apiUrl.nodeApi.getSubmitArticleList;
            let payload = {
                currentlyWith: [],
                stageId: [],
            };
            const response: any = await invokePostService(
                url,
                payload,
                props.isToken
            );
            setLoader(false);

            if (!response.data.data.isSuccess)
                throw new Error(response.data.data.Error);

            // I am Filtering out duplicates based on articleid
            const uniqueResults = response.data.data.result;

            // Adding the serial numbers
            uniqueResults.forEach((list: any, i: any) => {
                list.serial = i + 1;
            });
            setTableData(uniqueResults);
            setInitialData(uniqueResults);
        } catch (error) {
            toastError(`Get Article List ${error}`);
            setLoader(false);
        }
    };

    const getUserRole = async (type: any) => {
        try {
            let url = apiUrl.nodeApi.getUserRoles;
            // const response = await axios.get(`${config.prapp.basURL}${url}`);
            const response: any = await invokeGetService(url, {}, {}, props.isToken);
            if (!response.data.data.isSuccess)
                throw new Error(response.data.data.Error);
            response.data.data.result.unshift({
                label: "All Users",
                value: "Currently with All",
                id: "0",
            });
            setCurrentlyDropdown(response.data.data.result);
        } catch (error) { }
    };

    const getStagesList = async (type: any) => {
        try {
            let url = apiUrl.nodeApi.getReviewerStages;
            // const response = await axios.get(`${config.prapp.basURL}${url}`, {
            //     headers: {
            //         'authorization': `Bearer ${props.isToken}`,
            //         'Content-Type': 'application/json',
            //     },
            // });
            let payload = {
                userid: props?.userInfo?.userid
            }
            const response: any = await invokePostService(
                url,
                payload,
                props.isToken
            );
            if (!response.data.data.isSuccess)
                throw new Error(response.data.data.Error);
            response.data.data.result.unshift({
                label: "All Status",
                value: "All Status",
                id: "0",
            });
            setStageDropdown(response.data.data.result);
        } catch (error) {
            // toastError(`Get journal title list option error ${error}`)
        }
    };

    const handleSearch = (e: any) => {
        setContentId(0);
        // setStatusValue('All Status');
        let data: any = "";
        const searchTerm = e.target.value.toLowerCase();
        if (searchTerm.length === 0) {
            if (selectfileterData.length > 0) {
                // setTableData(initialData)
                data = selectfileterData;
                setRender(!render);
            } else {
                if (stageValue.label == "All Status" && currentlywithValue.label == "All Users") {
                    data = initialData;
                } else {
                    data = [];
                }
                setRender(!render);
            }
        } else {
            if (selectfileterData.length > 0) {
                const filteredData = selectfileterData.filter((row: any) => {
                    return Object.values(row).some(
                        (value: any) =>
                            value &&
                            value.toString().toLowerCase().includes(searchTerm.toLowerCase())
                    );
                });
                // setTableData(filteredData);
                data = filteredData;
            } else {
                if (stageValue.label == "All Status" && currentlywithValue.label == "All Users") {
                    const filteredData = initialData.filter((row: any) => {
                        return Object.values(row).some(
                            (value: any) =>
                                value &&
                                value.toString().toLowerCase().includes(searchTerm.toLowerCase())
                        );
                    });
                    data = filteredData;
                } else {
                    data = [];
                }
            }
        }

        if (data.length) {
            data.map((list: any, i: any) => {
                list.serial = i + 1;
            });
        }
        setTableData(data);
        setSearchData(searchTerm);
    };

    const handleMultiSelection = (e: any, type: any) => {
        if (e.value !== " ") {
            let updatedJournalValue = stageValue;
            let updatedAuthorValue = currentlywithValue;

            if (type === "stage") {
                updatedJournalValue = {
                    label: e.label,
                    value: e.value,
                };
            } else {
                updatedAuthorValue = {
                    label: e.label,
                    value: e.value,
                };
            }

            // Update the state values
            setStageValue(updatedJournalValue);
            setCurrentlyValue(updatedAuthorValue);

            // Pass the updated values directly to filterTableData
            filterTableData(updatedJournalValue, updatedAuthorValue);
        }
    };
    const iAuthorDetails = async (item: any) => {
        try {
            let url = apiUrl.nodeApi.getReviewerLink;
            const payload = {
                userId: item?.userid,
                articleGuid: item?.reviewerarticleguid
            };
            setLoader(true);
            const response: any = await invokePostService(
                url,
                payload,
                props.isToken
            );
            setLoader(false);

            if (!response.data.data.isSuccess) throw new Error(response.data.data.Error);
            if (response.data.data.isSuccess) {
                const newWindow = window.open(response.data.data.result, '_blank');
                if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
                    toastWarning("Browser blocked pop-ups. Click the pop-up blocker icon in the address bar and choose 'Allow pop-ups for this site'.");
                }
            }
        } catch (error: any) {
            setLoader(false);

            if (error.message === '[object Object]') {
                getJournalTitelList("table_list");
                toastSuccess("Status updated successfully! Click again to proceed");
            } else {
                toastError(`${error}`);
            }
        }
    };



    const subMissionDetails = async (item: any) => {
        props.dispatchStepAction("1");
        let fileUploaddata = {
            journalid: item.journalid,
            articletype: 0,
            filename: item.articlename,
            articleid: item.articleid,
            journaltitle: item.journalname
        }
        props.dispatchFileUpload(fileUploaddata);
        navigate("/createnewarticle", { state: { data: item } });
    };

    const pdfDetails = async (item: any) => {
        try {
            let url = apiUrl.nodeApi.getArticleReportDownloadUrl;
            const queryParams = { articleId: item.articleid };
            setLoader(true);
            const response: any = await invokeGetService(
                url,
                {},
                queryParams,
                props.isToken
            );
            setLoader(false);

            if (!response.data.isSuccess) throw new Error(response.data.Error);

            if (response.data.isSuccess) {
                const newWindow = window.open(response.data.result.downloadUrl, '_blank');
                if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
                    toastWarning("Browser blocked pop-ups. Click the pop-up blocker icon in the address bar and choose 'Allow pop-ups for this site'.");
                }
            }
        } catch (error) {
            toastError(`${error}`);
            setLoader(false);
        }
    };


    const handleModalClose = () => {
        setMsgModal(!isMsgModal);
    };
    const handleMsgSubmit = () => { };
    const handleMessageBox = (e: any, type: any) => {
        setMessageContent(e.target.value);
    };

    const refreshTable = () => {
        setStageValue({
            label: "All Status",
            value: "All Status",
        });
        setCurrentlyValue({
            label: "All Users",
            value: "Currently with All",
        });

        getJournalTitelList("stages");
    };
    const addFileUpload = () => {
        props.dispatchStepAction("0");
        navigate("/createnewarticle");
    };

    const handleConfirmationModalClose = () => setisAcceptModalshow(false);
    const handleModalOpen = (status: any) => {
        setConfirmationStatus(status);
        setisAcceptModalshow(true);
    };

    const handleConfirmation = () => {
        handleUpdateReviewerInviteStatus(confirmationStatus);
        handleConfirmationModalClose();
    };


    const handleDeclineConfirmationModalClose = () => setisDeclineModalshow(false);
    const handleDeclineModalOpen = (status: any) => {
        setdeclineconfirmationStatus(status);
        setisDeclineModalshow(true);
    };
    const handleDeclineConfirmation = () => {
        handleUpdateReviewerInviteStatus(declineconfirmationStatus);
        handleDeclineConfirmationModalClose();
    };
    return (
        <>
            {isLoader && <WHSLoader></WHSLoader>}
            <Modal show={isAcceptModalshow} centered onHide={handleConfirmationModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Action</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to accept this invite?</p>
                </Modal.Body>
                <Modal.Footer className="messageBox d-flex">
                    <Button onClick={handleConfirmation}>OK</Button>
                    <Button
                        className="ml-3"
                        variant="outline-secondary"
                        onClick={handleConfirmationModalClose}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={isDeclineModalshow} centered onHide={handleDeclineConfirmationModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Action</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to decline this invite?</p>
                </Modal.Body>
                <Modal.Footer className="messageBox d-flex">
                    <Button onClick={handleDeclineConfirmation}>OK</Button>
                    <Button
                        className="ml-3"
                        variant="outline-secondary"
                        onClick={handleDeclineConfirmationModalClose}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={isMsgModal} centered onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Send Message</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 form-group">
                            <label className="col-form-label">
                                Message <span className="error"> *</span>
                            </label>
                            <textarea
                                maxLength={1000}
                                placeholder={"Write message"}
                                value={message}
                                name="comments"
                                className="form-control"
                                onChange={(e: any) => handleMessageBox(e, "reason")}
                                id="comments"
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="messageBox d-flex">
                    <Button onClick={handleMsgSubmit}>SAVE</Button>
                    <Button
                        className="ml-3"
                        variant="outline-secondary"
                        onClick={handleModalClose}
                    >
                        CANCEL
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={isModalshow} centered onHide={() => { setisModalshow(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Additional Comments:</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row" style={{ textAlign: "start", paddingLeft: '20px' }}>
                        <p className="pt-15">
                            <p className=" d-flex gap-10">
                                Status
                                <span
                                    className="cellStyle"
                                    style={{
                                        color: getSuggestionTitleColor(
                                            suggestion
                                        ),
                                        backgroundColor: "rgb(244, 245, 250)",
                                        marginTop: "-5px",
                                    }}
                                >
                                    {suggestion}
                                </span>
                            </p>
                            <div
                                style={{
                                    backgroundColor: "#f4f5fa",
                                    marginRight: "20px",
                                    borderRadius: "10px",
                                    width: '400px'
                                }}
                            >
                                <p style={{ padding: "20px" }}>
                                    {messageuggestion}
                                </p>
                            </div>
                        </p>
                    </div>
                </Modal.Body>

            </Modal>
            <div className="page-title">
                <h3>Manuscript Summary</h3>

            </div>
            <div className="mb-5">
                <div className="table-filter">
                    <div className="row justify-content-between">
                        <div className="col-lg-4 search-input">
                            <WMSInput
                                type="text"
                                placeHolder="Search by Article ID, Article Title and Journal..."
                                className="form-control"
                                value={searchData}
                                onChange={(e: any) => handleSearch(e)}
                                id="search-table"
                            />
                            <span className="material-icons">search</span>
                        </div>
                        <div className="d-flex col-lg-8 table-dropdown-filter">
                            <div className="d-flex">
                                <label>Filter by</label>
                                <div className="table-dropdown-filter-inner">

                                    <WMSSelect
                                        className="form-control"
                                        placeHolder="Select..."
                                        options={stageDropdown}
                                        name="fileTypes"
                                        value={stageValue}
                                        isMulti={false}
                                        onChange={(e: any) => handleMultiSelection(e, "stage")}
                                        id="fileTypes"
                                    />
                                    <Button
                                        className="btn btn-primary refresh-btn"
                                        onClick={() => refreshTable()}
                                    >
                                        <span className="material-icons">refresh</span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    {isTableLoader ? (
                        <TableLineLoader />
                    ) : (
                        <>
                            {/* <WMSSimpleTable
                            isTableLoader={isTableLoader}
                            columns={columns}
                            tableData={tableData}
                            isPagination={true}
                            pageValue={pagination}
                            recordPerpage={recordpage}
                            iAuthorDetails={(item: any) => iAuthorDetails(item)} //this is for iauthor link button
                            pdfDetails={(item: any) => pdfDetails(item)} //this is for pdf details
                            subMissionDetails={(item: any) => subMissionDetails(item)} // this is for submission detail popup
                        /> */}
                            <CustomTable
                                columns={taskColumns}
                                data={tableData}
                                showPagination={true}
                                isSearchable={false}
                            />
                        </>
                    )}
                </div>
            </div>
        </>
    );
}
const mapStateToProps = (state: any) => {
    return {
        isLogged: state.rootReducer.authReducer.isLoggedIn,
        isToken: state.rootReducer.authReducer.token,
        userInfo: state.rootReducer.authReducer.userInfo,

    };
};
const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchStepAction: (stepCounter: any) => {
            dispatchStepAction(dispatch, stepCounter);
        },
        dispatchFileUpload: (fileUploaddata: any) => {
            dispatchFileUpload(dispatch, fileUploaddata);
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(HOCAutoLogout(ReviewerManuscript));